export default {

    API_URL: "/api",

    GOOGLE_ANALYTICS_ENABLED: true,
    FACEBOOK_PIXEL_ENABLED: true,   
    IUGU_TEST_MODE: false,
}